import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    transition: 'margin 0.4s ease',
  },
  inputWrapper: {
    marginTop: theme.spacing(1),
  },
  placeholder: {
    opacity: '0.6',
    lineHeight: '36px',
    marginRight: theme.spacing(2),
  },
  iconButton: {
    marginTop: `${theme.spacing(-1)} !important`,
    marginBottom: `${theme.spacing(-1)} !important`,
    marginLeft: '0px !important',
    verticalAlign: 'top !important',
  },
  text: {
    marginBottom: `${theme.spacing(3)} !important`,
  },
  specializations: {
    marginTop: theme.spacing(3),
  },
  experience: {
    padding: theme.spacing(2, 0),
  },
  slider: {
    padding: theme.spacing(0, 1),
  },
}))
